<app-reservation-search
	*ngIf="data.type === DialogType.RESERVATION"
	[whiteInput]="false"
	[redirectToRes]="false"
	(setReservationId)="setResId($event)"
></app-reservation-search>

<div *ngIf="data.type === DialogType.USER" class="d-flex align-items-center">
	<label class="me-3">Wyszukaj:</label>
	<mat-form-field class="w-100">
		<mat-chip-grid #chipList>
			<mat-chip-row *ngFor="let user of users" (removed)="remove(user)" [value]="user">
				{{ user.firstName }} {{ user.lastName }}
				<button matChipRemove>
					<i class="fas fa-times"></i>
				</button>
			</mat-chip-row>
		</mat-chip-grid>
		<input #userInput [formControl]="userCtr" [matChipInputFor]="chipList" [matAutocomplete]="auto" />
		<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
			<mat-option *ngFor="let user of filteredUsers | async" [value]="user">
				{{ user.firstName }} {{ user.lastName }} | {{ user.email }}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>
</div>
<div class="d-flex justify-content-end">
	<button
		[disabled]="
			(!resId && data.type === DialogType.RESERVATION) || (!users.length && data.type === DialogType.USER)
		"
		color="primary"
		mat-raised-button
		(click)="assignThreads()"
	>
		Przypisz
	</button>
</div>
